import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import classes from './auth-error-modal.module.css';

interface AuthErrorModalProps {
  title: string;
  message: string;
  onClose: () => void;
}

const AuthErrorModal: React.FC<AuthErrorModalProps> = ({ title, message, onClose }) => {
  return (
    <div className={classes.backdrop} role="presentation" onClick={onClose}>
      <section
        className={classes.modal}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="auth-error-title"
        aria-describedby="auth-error-message"
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className={classes.closeButton} onClick={onClose} aria-label="Close error message">
          <FaTimes />
        </button>
        <div className={classes.iconWrap}>
          <FaExclamationTriangle />
        </div>
        <div className={classes.copy}>
          <h2 id="auth-error-title">{title}</h2>
          <p id="auth-error-message">{message}</p>
        </div>
        <button type="button" className={classes.actionButton} onClick={onClose}>
          Try Again
        </button>
      </section>
    </div>
  );
};

export default AuthErrorModal;
